import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { Badge } from '../Badge/Badge.mjs';

const CardBadgeWrapper = styled.div `
  margin-left: auto;
  flex-shrink: 0;
`;
const BadgePosition = styled(Badge) `
  margin-left: ${({ theme }) => theme.spaces[1]};
`;
const CardBadge = (props) => (jsx(CardBadgeWrapper, { children: jsx(BadgePosition, { ...props }) }));

export { CardBadge };
